import { render, staticRenderFns } from "./HistoryEntryDetail.vue?vue&type=template&id=bcf5fbae&scoped=true&"
import script from "./HistoryEntryDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryEntryDetail.vue?vue&type=script&lang=js&"
import style0 from "./HistoryEntryDetail.vue?vue&type=style&index=0&id=bcf5fbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf5fbae",
  null
  
)

export default component.exports